<form *ngIf="isFormInitialized"
      class="tree filter-editor mxs-filter"
      [formGroup]="filterForm">
    <!--    container for root group-->
        <ng-container *ngTemplateOutlet="group; context:{form: filterForm}"></ng-container>
    <!--    container for tree of children-->
        <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: filterForm.get('childs')}"></ng-container>
</form>

<ng-template #recursiveList let-form>
    <ng-container *ngFor="let item of form.controls; let i = index">
        <div class="tree-item">
            <div *ngIf="item.controls.type.value === 'group'">
                <ng-container *ngTemplateOutlet="group; context:{form: item, parentForm: form, index: i}"></ng-container>
            </div>

            <div *ngIf="item.controls.type.value === 'rule'">
                <ng-container *ngTemplateOutlet="rule; context:{form: item.controls.ruleInfo, parentForm: form, index: i}"></ng-container>
            </div>
        </div>

        <div class="sub-tree" [ngClass]="{'sub-tree--readonly': readonly}" *ngIf="item.get('childs')?.controls?.length">
            <ng-container
                    *ngTemplateOutlet="recursiveList; context:{ $implicit: item.get('childs')}"></ng-container>
        </div>
    </ng-container>
</ng-template>


<ng-template #group let-form="form" let-parentForm="parentForm" let-index="index">
    <div class="filter-line group" [formGroup]="form">
        <button matTooltip="Remove group"  mat-button class="mxs-filter_button mxs-filter_button--remove"
                *ngIf="!readonly && parentForm"
                (click)="removeFormNode(parentForm, index)">
            <mat-icon>clear</mat-icon>
        </button>
        <mat-form-field class="filter-group">
            <mat-select hideSingleSelectionIndicator="true" formControlName="groupType">
                <mat-option value="and">AND</mat-option>
                <mat-option value="or">OR</mat-option>
                <mat-option value="nand">NAND</mat-option>
                <mat-option value="nor">NOR</mat-option>
            </mat-select>
            <mat-hint *ngIf="filterComparisonField && form.value.groupDifference.key"
                      matTooltip="{{form.value.groupDifference.value}}">
                {{form.value.groupDifference.value}}
            </mat-hint>
        </mat-form-field>

        <button matTooltip="Add rule" class="mxs-filter_button mxs-filter_button--addRule" mat-button *ngIf="!readonly"
                (click)="addRule(form)">
            <mat-icon>add</mat-icon>
        </button>
        <button matTooltip="Add group" class="mxs-filter_button mxs-filter_button--addGroup" mat-button *ngIf="!readonly"
                (click)="addGroup(form)">
            <mat-icon>ballot</mat-icon>
        </button>
        <button matTooltip="Reset filter" mat-button class="mxs-filter_button mxs-filter_button--remove"
                *ngIf="!readonly && !parentForm"
                (click)="resetFilter(form)">
            <mat-icon>clear_all</mat-icon>
        </button>
    </div>
</ng-template>

<ng-template #rule let-form="form" let-parentForm="parentForm" let-index="index">
    <div class="filter-line rule" [formGroup]="form">
        <button matTooltip="Remove rule" mat-button class="mxs-filter_button mxs-filter_button--remove"
                *ngIf="!readonly"
                (click)="removeFormNode(parentForm, index)" >
            <mat-icon>clear</mat-icon>
        </button>

        <mat-form-field class="filter-variable">
            <mat-select hideSingleSelectionIndicator="true" [id]="form.tracker"
                        formControlName="variable"
                        (selectionChange)="variableChanged($event, form)">
                <mat-option *ngFor="let trackerVar of variables" [value]="trackerVar.name">
                    {{trackerVar.name}}
                </mat-option>
            </mat-select>
            <mat-hint *ngIf="(filterComparisonField && form.controls.difference.value.key === 'variable')"
                      matTooltip="{{form.controls.difference.value.value}}">
                {{form.controls.difference.value.value}}
            </mat-hint>
        </mat-form-field>

        <ng-container *ngIf="form.controls.variable.value">
            <mat-form-field *ngIf="getVariableType(form.controls.variable.value) === 'MAP_STRING' || getVariableType(form.controls.variable.value) === 'ADV_TAG'"
                            class="filter-variable" >
                <input matInput
                       formControlName="subVariable" />
                <mat-hint *ngIf="(filterComparisonField && form.controls.difference.value.key === 'subVariable')"
                          matTooltip="{{form.controls.difference.value.value}}">
                    {{form.controls.difference.value.value}}
                </mat-hint>
            </mat-form-field>

            <mat-form-field class="filter-operator">
                <mat-select hideSingleSelectionIndicator="true" formControlName="operator"
                            (click)="savePreviousOperatorValue(form.controls.operator)"
                            (selectionChange)="operatorChanged($event, form)">
                    <mat-option *ngFor="let filterOperator of getOperatorOptions(form.controls.variable.value)"
                                [value]="filterOperator.key" >
                        {{filterOperator.name}}
                    </mat-option>
                </mat-select>
                <mat-hint *ngIf="(filterComparisonField && form.controls.difference.value.key === 'operator')"
                          matTooltip="{{form.controls.difference.value.value }}">
                    {{form.controls.difference.value.value}}
                </mat-hint>
            </mat-form-field>


            <ng-container *ngFor="let operand of form.controls['operands']?.controls; let index = index">
                <button matTooltip="Remove additional operand" mat-button class="mxs-filter_button mxs-filter_button--minusOne"
                        *ngIf="!readonly && isDynamicOperandsList(form.controls.operator.value)"
                        (click)="removeOperand(form.controls.operands, index)">
                    <mat-icon>remove_circle_outline</mat-icon>
                </button>

                <ng-container [ngSwitch]="getVariableType(form.controls.variable.value)">

                    <mat-form-field class="filter-operand" *ngSwitchCase="'STRING'">
                        <input matInput
                               [formControl]="operand"/>
                        <mat-error *ngIf="operand.invalid">Invalid value</mat-error>
                        <mat-hint *ngIf="(filterComparisonField && form.controls.difference.value.key === 'operands'
                                                                && operand.value === form.controls.operands.value[0])"
                                  matTooltip="{{form.controls.difference.value.value}}">
                            {{form.controls.difference.value.value}}
                        </mat-hint>
                    </mat-form-field>
                    <mat-form-field class="filter-operand" *ngSwitchCase="'TAG'">
                        <input matInput
                               [formControl]="operand"/>
                        <mat-error *ngIf="operand.invalid">Invalid value</mat-error>
                        <mat-hint *ngIf="(filterComparisonField && form.controls.difference.value.key === 'operands'
                                                                && operand.value === form.controls.operands.value[0])"
                                  matTooltip="{{form.controls.difference.value.value}}">
                            {{form.controls.difference.value.value}}
                        </mat-hint>
                    </mat-form-field>

                    <mat-form-field class="filter-operand" *ngSwitchCase="'NUMBER'">
                        <input matInput
                               type="number"
                               [formControl]="operand"/>
                        <mat-error *ngIf="operand.invalid">Invalid value</mat-error>
                        <mat-hint *ngIf="(filterComparisonField && form.controls.difference.value.key === 'operands'
                                                                && operand.value === form.controls.operands.value[0])"
                                  matTooltip="{{form.controls.difference.value.value}}">
                            {{form.controls.difference.value.value}}
                        </mat-hint>
                    </mat-form-field>

                    <mat-form-field class="filter-operand filter-operand--date" *ngSwitchCase="'DATE'">
                        <div class="date-field">
                            <input matInput
                                    [matDatepicker]="picker"
                                    [formControl]="operand"/>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker (opened)="onOpen(datepickerFooter)"></mat-datepicker>
                        </div>
                        <div style="display: none">
                            <div class="datepicker-footer" #datepickerFooter style="
                                display: flex;
                                justify-content: space-evenly; margin-bottom: 10px">
                                <button mat-raised-button color="primary" style="border-radius: 28px" (click)="today(operand, picker)">
                                    Today
                                </button>
                            </div>
                        </div>
                        <mat-error *ngIf="operand.invalid">Invalid value</mat-error>
                        <mat-hint *ngIf="(filterComparisonField && form.controls.difference.value.key === 'operands'
                                                                && operand.value === form.controls.operands.value[0])"
                                  matTooltip="{{form.controls.difference.value.value}}">
                            {{form.controls.difference.value.value}}
                        </mat-hint>
                    </mat-form-field>

                    <ng-container *ngSwitchCase="'DATETIME'">
                        <mat-form-field class="filter-operand filter-operand--date date-field">
                            <mat-datetimepicker-toggle matSuffix [for]="datetimePicker"></mat-datetimepicker-toggle>
                            <mat-datetimepicker type="datetime" #datetimePicker></mat-datetimepicker>
                            <input matInput
                                   [formControl]="operand"
                                   [matDatetimepicker]="datetimePicker"
                                   (click)="datetimePicker.open()"
                            />
                            <mat-error *ngIf="operand.invalid">Invalid value</mat-error>
                            <mat-hint *ngIf="(filterComparisonField && form.controls.difference.value.key === 'operands'
                                                                    && operand.value === form.controls.operands.value[0])"
                                      matTooltip="{{form.controls.difference.value.value}}">
                                {{form.controls.difference.value.value}}
                            </mat-hint>
                        </mat-form-field>
                    </ng-container>

                    <mat-form-field class="filter-operand filter-operand--date date-field" *ngSwitchCase="'TIME'">
                        <mat-datetimepicker-toggle matSuffix [for]="timePicker"></mat-datetimepicker-toggle>
                        <mat-datetimepicker type="time" #timePicker></mat-datetimepicker>
                        <input matInput
                               [formControl]="operand"
                               [matDatetimepicker]="timePicker"
                               (click)="timePicker.open()"
                        />
                        <mat-error *ngIf="operand.invalid">Invalid value</mat-error>
                        <mat-hint *ngIf="(filterComparisonField && form.controls.difference.value.key === 'operands'
                                                                && operand.value === form.controls.operands.value[0])"
                                  matTooltip="{{form.controls.difference.value.value}}">
                            {{form.controls.difference.value.value}}
                        </mat-hint>
                    </mat-form-field>

                    <mat-form-field class="filter-operand" *ngSwitchCase="'MAP_STRING'">
                        <input matInput
                                [formControl]="operand" />
                        <mat-error *ngIf="operand.invalid">Invalid value</mat-error>
                        <mat-hint *ngIf="(filterComparisonField && form.controls.difference.value.key === 'operands'
                                                                && operand.value === form.controls.operands.value[0])"
                                  matTooltip="{{form.controls.difference.value.value}}">
                            {{form.controls.difference.value.value}}
                        </mat-hint>
                    </mat-form-field>
                    <mat-form-field class="filter-operand" *ngSwitchCase="'ADV_TAG'">
                        <input matInput
                               [formControl]="operand" />
                        <mat-error *ngIf="operand.invalid">Invalid value</mat-error>
                        <mat-hint *ngIf="(filterComparisonField && form.controls.difference.value.key === 'operands'
                                                                && operand.value === form.controls.operands.value[0])"
                                  matTooltip="{{form.controls.difference.value.value}}">
                            {{form.controls.difference.value.value}}
                        </mat-hint>
                    </mat-form-field>

                    <mat-form-field class="filter-operand" *ngSwitchCase="'LIST'">
                        <mat-select hideSingleSelectionIndicator="true" [formControl]="operand"
                                    (closed)="searchOption.value=null"
                                    (opened)="searchOption.focus()">
                            <div class="search-input-wrapper">
                                <mat-form-field class="mxs-input mat-input-field" >
                                    <input matInput #searchOption/>
                                </mat-form-field>
                            </div>
                            <mat-option *ngFor="let filterOperator of getDynamicOperands(form.controls.variable.value) | filter:'value': searchOption.value"
                                    [value]="filterOperator.key" >
                                {{filterOperator.value}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="operand.invalid">Invalid value</mat-error>
                        <mat-hint *ngIf="(filterComparisonField && form.controls.difference.value.key === 'operands'
                                                                && operand.value === form.controls.operands.value[0])"
                                  matTooltip="{{form.controls.difference.value.value}}">
                            {{form.controls.difference.value.value}}
                        </mat-hint>
                    </mat-form-field>
                </ng-container>
            </ng-container>

            <button matTooltip="Add additional operand" mat-button class="mxs-filter_button mxs-filter_button--plusOne"
                    *ngIf="!readonly && isDynamicOperandsList(form.controls.operator.value)"
                    (click)="addOperand(form.controls.operands)">
                <mat-icon>plus_one</mat-icon>
            </button>

        </ng-container>
    </div>
</ng-template>
